<app-dashboard-cell-widget [cell]="cell"></app-dashboard-cell-widget>
<app-dashboard-cell-columns [cell]="cell"></app-dashboard-cell-columns>
<app-dashboard-cell-rows [cell]="cell"></app-dashboard-cell-rows>
<!--app-dashboard-cell-rank [cell]="cell"></app-dashboard-cell-rank-->
<app-dashboard-cell-display [cell]="cell"></app-dashboard-cell-display>
<hr>
<app-dashboard-cell-remove [cell]="cell" (sendRemove)="receiveRemove($event)"></app-dashboard-cell-remove>